import { Icon } from '@axo/ui-core/components/Icon';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Text } from '@axo/ui-core/components/typography';
import styles from './refinanceSavings.module.scss';

type SavingsCardProps = {
  key: string;
  title: string;
  value: string;
};

type RefinanceSavingsProps = {
  title: string;
  disclaimer?: string;
  savingCards: SavingsCardProps[];
  disabled?: boolean;
};

export const RefinanceSavings = ({
  title,
  disclaimer,
  savingCards,
  disabled = false,
}: RefinanceSavingsProps) => {
  return (
    <Stack
      gap="3xs"
      className={styles.refinanceSavings}
      data-disabled={disabled}
    >
      <div className={styles.title}>
        <Icon name="piggy-bank-solid" />
        <Text size="m">{title}</Text>
      </div>

      <Stack gap="3xs" direction="h" align="stretch">
        {savingCards.map(({ key, title, value }) => (
          <div
            key={key}
            className={styles.savingCard}
            data-row={savingCards.length === 1}
          >
            <Text size="l">{value}</Text>
            <Text size="s">{title}</Text>
          </div>
        ))}
      </Stack>

      {disclaimer && <Text size="s">{disclaimer}</Text>}
    </Stack>
  );
};
